import { h, setChildren } from "../core/dom.js";
import { api } from "../api.js";
import { muscleName } from "../store.js";
import { openModal, spinner } from "./ui.js";
import { MuscleMap } from "./MuscleMap.js";
import { exerciseImgSrc } from "./common.js";
import { icon } from "../lib/icons.js";

// A read-only "what does this exercise look like / how to do it" modal, reused by
// the workout editor and the exercise picker (no personal history — just the move).
export function openExerciseDetail(id) {
  const body = h("div", null, spinner());
  const modal = openModal({ title: "Exercise", content: body, fullscreen: true });
  api
    .exercise(id)
    .then((ex) => setChildren(body, view(ex)))
    .catch(() => setChildren(body, h("p", { class: "dim center", style: { padding: "30px" } }, "Couldn't load this exercise.")));
  return modal;
}

function view(ex) {
  const chips = [ex.equipment, ex.level, ex.mechanic, ex.force, ex.category].filter(Boolean);
  return h(
    "div",
    null,
    h("h2", { style: { margin: "0 0 4px" } }, ex.exercise_name),
    ex.creator && ex.creator !== "Original"
      ? h("div", { class: "dim", style: { fontSize: ".8rem", marginBottom: "10px" } }, `Added by ${ex.creator}`)
      : null,
    chips.length ? h("div", { class: "chip-row", style: { marginBottom: "12px" } }, ...chips.map((t) => h("span", { class: "chip" }, t))) : null,

    ex.video_url
      ? h("a", { href: ex.video_url, target: "_blank", rel: "noopener noreferrer",
          style: { display: "inline-flex", gap: "6px", alignItems: "center", marginBottom: "12px", color: "var(--accent)", textDecoration: "none", fontWeight: 600 } },
          icon("play", { size: 16, fill: true }), "Watch demo")
      : null,

    (ex.images || []).length
      ? h("div", { class: "card", style: { padding: "10px" } }, ...ex.images.map((img) => h("img", { src: exerciseImgSrc(img), alt: "", loading: "lazy", style: { width: "100%", borderRadius: "12px", marginBottom: "8px", display: "block" } })))
      : null,

    h("div", { class: "section-title" }, "Target muscles"),
    h(
      "div",
      { class: "card", style: { padding: "10px" } },
      MuscleMap({ primary: ex.primary_muscle_ids, secondary: ex.secondary_muscle_ids }),
      h(
        "div",
        { class: "chip-row", style: { marginTop: "8px", justifyContent: "center" } },
        ...(ex.primary_muscle_ids || []).map((id) => h("span", { class: "badge badge-muscle" }, muscleName(id))),
        ...(ex.secondary_muscle_ids || []).map((id) => h("span", { class: "badge badge-muscle secondary" }, muscleName(id)))
      )
    ),

    ex.instructions?.length
      ? h("div", null, h("div", { class: "section-title" }, "How to do it"), h("div", { class: "card" }, h("ol", { style: { paddingLeft: "20px", display: "flex", flexDirection: "column", gap: "8px" } }, ...ex.instructions.map((i) => h("li", null, i)))))
      : null
  );
}
